import React from 'react'

import '../ChatBot.css'
import { motion } from 'framer-motion'


export default function InnerBotAvatar({ message, isLastBotMessage, urlBotImage }) {

    return (
        <>
            <div className='col-1'>
                <motion.div
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                >

                    <div className='flex flex-column align-items-center'>
                        {isLastBotMessage ?
                            <>
                                <img
                                    src={urlBotImage}
                                    alt="avatar"
                                    className="avatar"
                                />
                                <span className=" message-time">{message.time}</span>
                            </>
                            :
                            <div className="avatar"></div>
                        }
                    </div>


                    
                </motion.div>
            </div>

        </>

    )

}